import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import ThirdPartyButtons from "./widget/SignupThirdPartyButtons";
import SignupThirdPartyContent from "./SignupThirdPartyContent";
import { SignupThirdPartySelectionContextProvider } from "../../../../provider/onboarding/signup/third_party_selection/SignupThirdPartySelectionContextProvider";
import AppConfigService from "../../../../service/app_config/AppConfigService";

const SignupThirdPartyScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <SignupThirdPartySelectionContextProvider>
      <Scaffold
        appBarTitle={
          type === 3 ? undefined : AppConfigService.get("company_name")
        }
        bottomNavigationButton={type === 3 ? <ThirdPartyButtons /> : <></>}
      >
        <MainBodyContainer className="h-100">
          <SignupThirdPartyContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SignupThirdPartySelectionContextProvider>
  );
};

export default SignupThirdPartyScreen;
export const routeName: string = "/signup/third-party-selection";
